import type { SuggestionOptions } from '@tiptap/suggestion'
import { createSuggestionRenderer } from '../suggestionRenderer'
import { PlaceholderList } from './PlaceholderList'
import {
  type GroupedPlaceholderItems,
  getPlaceholderData
} from './placeholderData'

const placeholderSuggestion = (
  placeholderCategories?: string[],
  placeholderItemsFilter?: string[]
): Omit<SuggestionOptions<GroupedPlaceholderItems>, 'editor'> => ({
  char: '/',
  command: ({ editor, range, props }) => {
    editor
      .chain()
      .focus()
      .deleteRange(range)
      .insertContent(
        `<span data-placeholder-node data-category="${props.category}" data-placeholder="${
          props.placeholder
        }" data-label="${props.label}">${props.placeholder}</span> `
      )
      .run()
  },

  items: ({ query }: { query: string }) => {
    if (!query) {
      return [
        getPlaceholderData({
          categoriesFilter: placeholderCategories,
          itemsFilter: placeholderItemsFilter
        })
      ]
    }

    // Filter categories and items based on query
    const filtered = getPlaceholderData({
      categoriesFilter: placeholderCategories,
      itemsFilter: placeholderItemsFilter
    })
      .map((category) => {
        // Check if category matches the query
        const categoryMatch = category.category
          .toLowerCase()
          .includes(query.toLowerCase())

        // Filter items within the category
        const filteredItems = category.items.filter((item) =>
          item.label.toLowerCase().includes(query.toLowerCase())
        )

        // Return category with filtered items if there are matches
        if (categoryMatch || filteredItems.length > 0) {
          return {
            ...category,
            items:
              filteredItems.length > 0
                ? filteredItems
                : categoryMatch
                  ? category.items
                  : []
          }
        }

        return null
      })
      .filter(Boolean) as GroupedPlaceholderItems

    return [filtered]
  },

  allowSpaces: false,

  render: createSuggestionRenderer(PlaceholderList)
})

export default placeholderSuggestion
